import type { MarketTopic } from '../../types/market'

export const startTopics: MarketTopic[] = [
  {
    key: 'user-start',
    slug: 'primeros-pasos',
    title: 'Tu primera visita al mercado Vanguard',
    menu: 'Primeros pasos',
    summary: 'Reconoce cada espacio y completa tu primera compra o venta con la moneda web del mercado.',
    kind: 'user',
    related: ['user-account', 'user-recharge', 'user-publish', 'user-delivery'],
    aliases: ['empezar', 'como funciona el market', 'mercado', 'tienda', 'market', 'primera compra', 'primera venta'],
    questions: ['como empiezo en el market', 'que es vanguard market', 'que acciones exigen desconectar el juego'],
    checklist: ['Inicié sesión con el usuario de mi cuenta, no con el personaje', 'Sé dónde están Carrito, Mis compras, Vender y Mi wallet', 'Sé qué acciones exigen desconectar la cuenta completa del juego', 'Sé que las fechas del historial están en UTC'],
    sections: [
      {
        id: 'dos-vendedores',
        title: 'Un mercado con dos tipos de vendedores',
        blocks: [
          { t: 'p', text: 'Vanguard Market reúne la Tienda del servidor y las publicaciones De jugadores. El servidor ofrece solo consumibles: VIP, Panda Combo, Skeleton Combo, talismanes y servicios como resetear stats o árbol, cambiar raza y cambiar nombre. Los jugadores publican ítems compatibles que ya tienen en la mochila de un personaje.' },
          { t: 'p', text: 'Las compras se pagan con la moneda web indicada en la pantalla, por ejemplo CREDITS. Este saldo pertenece a la wallet del mercado; no es Zen, WCoin ni otra moneda del juego.' },
        ],
      },
      {
        id: 'navegacion',
        title: 'Encuentra cada herramienta en la navegación',
        blocks: [
          {
            t: 'table',
            head: ['Espacio', 'Para qué sirve'],
            rows: [
              ['Explorar / De jugadores', 'Buscar equipo y comparar publicaciones.'],
              ['Tienda del servidor', 'Consultar las ofertas oficiales y su duración.'],
              ['Carrito', 'Reunir productos y revisar el total antes de pagar.'],
              ['Mis compras', 'Consultar el historial y los ítems resguardados.'],
              ['Vender', 'Publicar desde la mochila y revisar publicaciones y ventas.'],
              ['Mi wallet', 'Ver saldo, movimientos, recargas y retiros.'],
            ],
          },
          { t: 'p', text: 'En el menú de tu nombre también encontrarás Mi wallet y Cerrar sesión.' },
        ],
      },
      {
        id: 'primera-compra',
        title: 'Ruta rápida para tu primera compra',
        blocks: [
          {
            t: 'steps',
            items: [
              'Inicia sesión con tu cuenta del servidor.',
              'Abre Mi wallet → Recargar con USDT si necesitas saldo.',
              'Genera la orden, realiza la transferencia y reporta su identificador. Espera la verificación manual.',
              'Elige productos, agrégalos al carrito y desconecta tu cuenta completa del juego.',
              'Revisa el total y el destino; confirma el pago.',
              'Consulta Mis compras. Si el ítem fue enviado al juego, retíralo desde Gremory → Cuenta.',
            ],
          },
        ],
      },
      {
        id: 'primera-venta',
        title: 'Ruta rápida para tu primera venta',
        blocks: [
          {
            t: 'steps',
            items: [
              'Desconecta tu cuenta completa del juego.',
              'Entra en Vender → Publicar un ítem.',
              'Selecciona el personaje, pulsa Ver mochila y elige un ítem admitido.',
              'Escribe el precio y revisa la comisión y lo que recibirás.',
              'Pulsa Resguardar y publicar. El ítem sale de tu mochila.',
              'Cuando se venda, el importe neto aparecerá en tu wallet.',
            ],
          },
        ],
      },
      {
        id: 'desconectar',
        title: 'Qué acciones exigen desconectar el juego',
        blocks: [
          { t: 'note', tone: 'warn', text: 'La cuenta completa debe estar desconectada para consultar la mochila para vender, publicar, cancelar una publicación, confirmar una compra o enviar un ítem resguardado al Gremory. Cerrar solo una ventana mientras otra sesión de la misma cuenta continúa conectada no cumple esta condición.' },
          { t: 'p', text: 'Puedes explorar, consultar historiales y gestionar recargas o solicitudes de retiro desde la web. La comprobación de cuenta desconectada corresponde a las operaciones de comercio y entrega relacionadas con el juego.' },
          { t: 'p', text: 'Las fechas del historial se muestran en UTC. Tenlo en cuenta al comparar una compra, pago o retiro con la hora de tu equipo.' },
        ],
      },
    ],
  },
  {
    key: 'user-account',
    slug: 'cuenta',
    title: 'Accede con tu cuenta del servidor',
    menu: 'Cuenta y sesión',
    summary: 'Usa tus credenciales existentes y reconoce la diferencia entre el acceso al Market y la conexión al juego.',
    kind: 'user',
    related: ['user-start', 'user-faq'],
    aliases: ['iniciar sesion', 'login', 'acceso', 'cuenta', 'contraseña', 'sesion', 'cerrar sesion', 'registro'],
    questions: ['como entro al market', 'por que me pide otra vez la contraseña', 'como cambio mi contraseña', 'como creo una cuenta para el market'],
    sections: [
      {
        id: 'iniciar-sesion',
        title: 'Inicia sesión desde el subdominio del mercado',
        blocks: [
          { t: 'steps', items: ['Abre market.mu-vanguard.com.', 'Pulsa el acceso para iniciar sesión.', 'Escribe el usuario de tu cuenta y su contraseña. El usuario no es el nombre de un personaje.', 'Pulsa Entrar a mi cuenta.'] },
          { t: 'shot', id: '03' },
          { t: 'p', text: 'La cuenta es la misma que ya existe en el servidor. No debes crear una segunda cuenta exclusiva para el mercado.' },
        ],
      },
      {
        id: 'sesion-independiente',
        title: 'La sesión del Market es independiente',
        blocks: [
          { t: 'p', text: 'Entrar en la web principal no inicia automáticamente esta sesión del subdominio. Es normal que el Market vuelva a pedir las credenciales. La sesión también puede expirar por inactividad; en ese caso, inicia sesión otra vez.' },
          { t: 'note', tone: 'info', text: 'El carrito y una revisión de compra en curso pertenecen a la sesión actual. Si cierras sesión o esta vence, puede ser necesario reconstruir el carrito y revisar de nuevo. Las compras confirmadas, créditos, recargas, retiros e ítems resguardados se conservan en tu cuenta.' },
        ],
      },
      {
        id: 'sin-acceso',
        title: 'Si todavía no tienes acceso a tu cuenta',
        extended: true,
        blocks: [
          { t: 'p', text: 'Cuando la administración configura la dirección del sitio principal, la pantalla de acceso muestra Crear mi cuenta de Vanguard y Olvidé mi contraseña. Esos enlaces llevan a los servicios de cuenta de la web principal.' },
          { t: 'p', text: 'Si no aparecen, utiliza el sitio principal o el canal de atención del servidor. El Market independiente no tiene un formulario propio para registrar cuentas o cambiar contraseñas.' },
        ],
      },
      {
        id: 'acceso-rechazado',
        title: 'Resuelve un inicio de sesión rechazado',
        extended: true,
        blocks: [
          { t: 'list', items: ['Comprueba que escribiste el usuario de cuenta y no el personaje.', 'Revisa espacios al copiar, mayúsculas y contraseña.', 'Si alcanzaste el límite de intentos, espera el plazo indicado por el sistema.', 'Si el mensaje indica que el acceso no está disponible, informa al administrador del mensaje y la hora.'] },
          { t: 'p', text: 'Para salir, abre el menú de tu nombre y pulsa Cerrar sesión. Esto cierra la sesión del mercado; no desconecta por sí mismo una cuenta abierta dentro del juego.' },
        ],
      },
    ],
  },
  {
    key: 'user-catalog',
    slug: 'catalogo',
    title: 'Explora el catálogo y reconoce sus etiquetas',
    menu: 'Catálogo',
    summary: 'Filtra por origen y categoría, ordena los resultados y consulta las opciones de cada ítem antes de elegir.',
    kind: 'user',
    related: ['user-product', 'user-official', 'user-cart'],
    aliases: ['comprar', 'catalogo', 'buscar item', 'filtros', 'categorias', 'ficha', 'tooltip', 'opciones', 'excellent', 'ancient', 'socket', 'luck'],
    questions: ['como compro', 'como busco un item', 'que significa excellent', 'como veo las opciones de un item', 'quien vende este item'],
    sections: [
      {
        id: 'buscar',
        title: 'Busca por el nombre de la publicación',
        blocks: [
          { t: 'p', text: 'Utiliza el buscador superior para escribir el nombre o una parte del nombre del ítem. La búsqueda compara el título de las publicaciones; no es un buscador de cuentas de vendedores ni un filtro específico de sockets u opciones.' },
          { t: 'p', text: 'El catálogo muestra hasta 24 publicaciones por página. Usa la navegación de páginas para seguir explorando. Si no encuentras resultados, borra la búsqueda o vuelve a Todas las categorías.' },
          { t: 'shot', id: '02' },
        ],
      },
      {
        id: 'filtros',
        title: 'Combina origen, categoría y orden',
        blocks: [
          { t: 'list', items: ['Todos: explora las ofertas disponibles del catálogo general.', 'Jugadores / De jugadores: consulta las piezas publicadas por la comunidad.', 'Tienda del servidor: abre la sección oficial con sus tipos de productos.', 'Categorías: Armas, Escudos, Armaduras, Alas y Accesorios.', 'Orden: Más recientes, Menor precio o Mayor precio.'] },
          { t: 'p', text: 'La tienda oficial solo ofrece consumibles (VIP, combos, talismanes y servicios de personaje). Las categorías de equipo corresponden a las publicaciones de jugadores.' },
        ],
      },
      {
        id: 'vendedor',
        title: 'Comprueba quién publicó cada oferta',
        blocks: [
          { t: 'p', text: 'Las tarjetas de jugadores muestran Publicado por: nombre de cuenta, por ejemplo Publicado por: takumi12. El vendedor es la cuenta que publicó, aunque el objeto haya salido de uno de sus personajes.' },
          { t: 'p', text: 'Las tarjetas oficiales se identifican como Vendido por: Servidor. Abre el detalle para consultar vendedor, precio, opciones y disponibilidad.' },
        ],
      },
      {
        id: 'etiquetas',
        title: 'Lee las etiquetas de cualidades',
        blocks: [
          {
            t: 'table',
            head: ['Etiqueta', 'Qué indica', 'Dónde ampliar'],
            rows: [
              ['Excellent', 'El ítem contiene opciones Excellent.', 'Ficha del ítem.'],
              ['Socket', 'El ítem pertenece al sistema de sockets.', 'Ficha para posiciones, semillas y bonus disponibles.'],
              ['Ancient', 'El objeto tiene una opción de set Ancient.', 'Ficha y descripción del objeto.'],
              ['Luck', 'El objeto tiene suerte.', 'Detalle y ficha.'],
            ],
          },
          { t: 'p', text: 'Una etiqueta resume una cualidad; no sustituye la lectura de las opciones. Dos ítems del mismo nombre pueden tener niveles, durabilidad, sockets y precios diferentes.' },
        ],
      },
      {
        id: 'ficha',
        title: 'Abre el tooltip de la ficha',
        blocks: [
          { t: 'p', text: 'Pulsa Ficha junto al nombre. En computadora también puedes pasar el puntero sobre la imagen de una tarjeta o sobre el botón. Con teclado, enfoca el botón y actívalo; en móvil, tócalo.' },
          { t: 'p', text: 'El clic mantiene la ficha abierta para leerla. Ciérrala con otro clic en el botón, tocando fuera o pulsando Escape. Si el contenido es largo, desplázate dentro de la ficha.' },
          { t: 'shot', id: '05' },
          { t: 'p', text: 'La ficha presenta los datos que puede interpretar el catálogo instalado: nivel, habilidad, suerte, opciones adicionales, Excellent, Ancient, Harmony, sockets y otras características pertinentes. Cuando falte información, el sistema lo advierte o muestra una ficha resumida.' },
        ],
      },
      {
        id: 'ilustraciones',
        title: 'Interpreta correctamente las ilustraciones',
        extended: true,
        blocks: [
          { t: 'p', text: 'Los iconos representan grupos de objetos: espadas, hachas, mazas, arcos, ballestas, bastones, libros, piezas de armadura y accesorios, entre otros. Son ilustraciones orientativas; no son una captura exacta del objeto equipado.' },
          { t: 'p', text: 'Para decidir una compra, guíate por el nombre, las opciones de la ficha y el detalle de la publicación. Si aparece un aviso de datos incompletos, consulta al administrador antes de confirmar.' },
        ],
      },
    ],
  },
  {
    key: 'user-product',
    slug: 'publicacion',
    title: 'Revisa la publicación antes de agregarla',
    menu: 'Detalle de la publicación',
    summary: 'Comprueba vendedor, precio, opciones, cantidad y condiciones de entrega en la ficha completa.',
    kind: 'user',
    related: ['user-catalog', 'user-official', 'user-cart', 'user-delivery'],
    aliases: ['detalle', 'publicacion', 'agregar al carrito', 'disponibilidad', 'proximamente disponible', 'compras pausadas'],
    questions: ['que significa proximamente disponible', 'puedo comprar mi propio item', 'agregar al carrito cobra'],
    sections: [
      {
        id: 'datos',
        title: 'Comprueba los datos de la oferta',
        blocks: [
          { t: 'p', text: 'Abre una tarjeta del catálogo para ver el título, vendedor, precio en moneda web y características. Según el producto, también encontrarás descripción, duración, momento de inicio de esa duración y disponibilidad.' },
          { t: 'p', text: 'En los ítems se muestran nivel, durabilidad, Skill / Suerte y la ficha de opciones. La sección Detalles de la publicación reúne los datos principales. La imagen representa una categoría.' },
          { t: 'shot', id: '04' },
        ],
      },
      {
        id: 'cantidad',
        title: 'Elige la cantidad que necesitas',
        blocks: [
          { t: 'p', text: 'Una publicación de jugador corresponde a una pieza única. No puedes aumentar su cantidad. Las ofertas del servidor permiten seleccionar unidades, sujetas al stock y a los límites del carrito.' },
          { t: 'note', tone: 'info', text: 'Pulsa Agregar al carrito para continuar. Esto todavía no realiza el cobro ni reserva el stock. Si estás viendo una publicación tuya, aparecerá la opción de administrarla; no puedes comprar tu propio ítem.' },
        ],
      },
      {
        id: 'mensajes',
        title: 'Entiende los mensajes de disponibilidad',
        blocks: [
          {
            t: 'table',
            head: ['Mensaje o acción', 'Qué hacer'],
            rows: [
              ['Iniciar sesión para comprar', 'Accede con tu cuenta y regresa al producto.'],
              ['Las compras están pausadas', 'Espera a que la administración active nuevas compras.'],
              ['Próximamente disponible', 'La oferta puede consultarse, pero su compra y entrega todavía no están habilitadas. No se cobra.'],
              ['Publicación no disponible', 'Puede haberse vendido, agotado, vencido o retirado. Busca otra oferta.'],
            ],
          },
        ],
      },
      {
        id: 'destino',
        title: 'Lee el destino antes de continuar',
        blocks: [
          { t: 'p', text: 'Si la entrega al juego está habilitada, los ítems se envían al Gremory de tu cuenta. Si no lo está, una compra de ítem permanente puede quedar resguardada en el mercado; la confirmación lo comunica expresamente.' },
          { t: 'p', text: 'Los consumibles de la tienda del servidor requieren una oferta con entrega habilitada. En todos los casos, revisa las condiciones de la pantalla final antes de pagar.' },
        ],
      },
    ],
  },
  {
    key: 'user-official',
    slug: 'tienda-del-servidor',
    title: 'Compra productos y beneficios del servidor',
    menu: 'Tienda del servidor',
    summary: 'La tienda del servidor ofrece solo consumibles: VIP, combos, talismanes y servicios para tu personaje.',
    kind: 'user',
    related: ['user-product', 'user-cart', 'user-checkout', 'user-delivery'],
    aliases: ['tienda oficial', 'tienda del servidor', 'vip', 'buff', 'buffs', 'consumibles', 'panda combo', 'skeleton combo', 'talisman', 'talismanes', 'resetear stats', 'reset stats', 'resetear arbol', 'reset arbol', 'cambiar raza', 'cambio de raza', 'cambiar nombre', 'cambio de nombre'],
    questions: ['que vende la tienda del servidor', 'cuando empieza a contar el vip', 'como reseteo mis stats', 'como cambio de raza', 'como cambio el nombre', 'donde compro panda combo', 'donde compro talismanes'],
    sections: [
      {
        id: 'que-ofrece',
        title: 'Qué ofrece la tienda oficial',
        blocks: [
          { t: 'p', text: 'Abre Tienda del servidor. Todas las publicaciones de esta sección pertenecen al servidor y se pagan con la misma wallet del mercado. La administración decide qué productos publicar, su stock, precio, descripción y duración.' },
          { t: 'p', text: 'En Vanguard la tienda del servidor vende únicamente consumibles. No vende armas, armaduras, alas ni otro equipo: ese equipo solo se compra a otros jugadores.' },
          {
            t: 'table',
            head: ['Producto', 'Para qué sirve'],
            rows: [
              ['VIP', 'Beneficio para tu cuenta durante el tiempo indicado en la oferta.'],
              ['Panda Combo', 'Paquete de consumibles; su contenido figura en la descripción de la oferta.'],
              ['Skeleton Combo', 'Paquete de consumibles; su contenido figura en la descripción de la oferta.'],
              ['Talismanes', 'Consumibles con el efecto descrito en cada oferta.'],
              ['Resetear stats', 'Servicio para volver a repartir los puntos de estadísticas.'],
              ['Resetear árbol', 'Servicio para volver a repartir los puntos del árbol.'],
              ['Cambiar raza', 'Servicio para cambiar la clase de un personaje.'],
              ['Cambiar nombre', 'Servicio para cambiar el nombre de un personaje.'],
            ],
          },
          { t: 'p', text: 'Los jugadores no pueden publicar estos productos desde su panel de vendedor.' },
          { t: 'shot', id: '06' },
          { t: 'note', tone: 'info', text: 'La captura es del manual y muestra filtros de demostración. La oferta real de Vanguard son los consumibles de la tabla.' },
        ],
      },
      {
        id: 'destino-duracion',
        title: 'Destino de cada producto',
        blocks: [
          { t: 'p', text: 'Antes de pagar, la pantalla de confirmación indica a dónde va cada producto: la cuenta (como el VIP), un personaje elegido, o el Gremory de cuenta si se entrega como objeto. Revisa ese destino y la descripción de la oferta, sobre todo en los servicios de personaje como resetear stats o árbol, cambiar raza o cambiar nombre.' },
          { t: 'note', tone: 'warn', text: 'El VIP empieza a contar al confirmar la compra. No esperes a entrar al juego para considerar activada su duración. Consulta el producto antes de confirmar.' },
        ],
      },
      {
        id: 'personaje-buffs',
        title: 'Elige el personaje para los buffs',
        blocks: [
          { t: 'p', text: 'Cuando el carrito contiene un buff, selecciona Personaje para los buffs antes de revisar la compra. Debe pertenecer a tu cuenta.' },
          { t: 'p', text: 'Todos los buffs de ese carrito se aplican al personaje seleccionado. El VIP y los ítems no cambian de destino por esta elección: el VIP pertenece a la cuenta y los ítems van al depósito de cuenta. Si necesitas buffs para otro personaje, prepara una compra separada.' },
        ],
      },
      {
        id: 'disponibilidad',
        title: 'Disponibilidad y reglas particulares del juego',
        extended: true,
        blocks: [
          { t: 'p', text: 'Una oferta puede estar visible como Próximamente disponible hasta que su entrega esté configurada. En ese estado no puedes pagarla.' },
          { t: 'p', text: 'Lee la descripción del producto y evita asumir que un segundo VIP o buff siempre se acumula con el que ya tienes. El servidor aplica sus reglas de compatibilidad y puede rechazar una combinación; si la compra no se confirma, revisa el mensaje y consulta al administrador.' },
          { t: 'table', head: ['Situación', 'Qué significa'], rows: [['Oferta visible', 'Puedes consultarla en el catálogo.'], ['Compra habilitada', 'Puedes pagarla con tu saldo disponible.'], ['Entrega habilitada', 'El Market puede enviarla al juego o aplicarla.'], ['Market pausado', 'No se aceptan compras ni publicaciones nuevas; tu saldo e historial se conservan.']] },
        ],
      },
      {
        id: 'resultado',
        title: 'Consulta el resultado de la compra',
        blocks: [
          { t: 'p', text: 'Después de pagar, abre Mis compras. Los beneficios confirmados aparecen como Aplicado; los ítems enviados muestran Enviado al Gremory. Para los buffs se identifica el personaje de destino.' },
          { t: 'p', text: 'La página del catálogo no sustituye el historial: usa el registro de la compra para comprobar qué recibiste y cuándo.' },
        ],
      },
    ],
  },
]
